<template>
  <div class="numero">404</div>
  Pàgina Inexistent
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
  }
})
</script>

<style>
.numero {
  color: orange;
  font-size: 4rem;
}
</style>
